import {vpost} from "@/util/post";

export const dealer = {
    list(pageSize, pageCurrent, key = "") { return vpost("/dealer/list", {pageSize, pageCurrent, key}); },
    detail(id) { return vpost("/dealer/detail?id=" + id); },
    create(name) { return vpost("/dealer/create", {name}); },
    update(id, name) { return vpost("/dealer/update", {id, name}); },
    delete(id) { return vpost("/dealer/delete?id=" + id); },
};
